import { Outlet } from "react-router-dom";
import { DebugWidget } from "@boundary/components/debugWidget";
import { MapLayout } from "./mapLayout";

export function AppLayout() {
  return (
    <>
      <MapLayout />
      <Outlet />
      <DebugWidget />
    </>
  );
}

